var _path, _circle, _circle2, _circle3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgLeftFeedback = function SvgLeftFeedback(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 88 88"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#FF5C32",
    strokeWidth: 4,
    d: "M27.172 82.596s1.517-7.495 12.665-13.513c6.4-3.456 17.206-1.422 27.423-7.396 22.855-13.363 15.655-51.246-27.424-48.55C-3.242 15.832.455 59.886 32.694 59.886"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 31.5,
    cy: 39.5,
    r: 2.5,
    fill: "#FF5C32"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 44.5,
    cy: 39.5,
    r: 2.5,
    fill: "#FF5C32"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 57.5,
    cy: 39.5,
    r: 2.5,
    fill: "#FF5C32"
  })));
};
export default SvgLeftFeedback;